import { ReactNode } from 'react';
import { escapeRegExp } from 'lodash';

export const highlightMatch = (text: string, query: string): ReactNode => {
    if (!query) {
        return text;
    }

    const escapedQuery = escapeRegExp(query);
    const regex = new RegExp(`(${escapedQuery})`, 'gi');
    const parts = text.split(regex);

    if (parts.length === 1) {
        return text;
    }

    return parts.map((part, i) =>
        regex.test(part) ? <mark key={i} style={{ backgroundColor: 'rgba(var(--ion-color-tertiary-rgb), 0.2)', borderRadius: 2, padding: '0 1px', color: 'inherit' }}>{part}</mark> : part
    );
};
